<template>
  <div class="documentation-topic">
    <div class="documentation-nav">
      <router-link to="/documentation"><h4 class="is-size-6">Back to Topics</h4></router-link>
    </div>
    <blob-browser-component :blobs="documents" :root-dir="rootDir" container="documents" :topic="getSelectedTopicName(rootDir)" :show-actions="false"></blob-browser-component>
  </div>
</template>

<script>
import BlobBrowserComponent from '../shared/file-storage/BlobBrowserComponent.vue';

export default {
  components: { BlobBrowserComponent },
  created() {
    this.rootDir = this.$route.query.rootDir || null;
  },
  data() {
    return {
      rootDir: null
    }
  },
  methods: {
    getSelectedTopicName(rootDir) {
      const parts = rootDir.split('/');
      return parts[parts.length - 1].replace('-', ' ');
    }
  },
  computed: {
    documents() {
      return this.$store.state.storage.documents;
    }
  }
}
</script>

<style lang="scss" scoped>
  .documentation-topic {
    .documentation-nav {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }
</style>
